/* DH Styling product stories — source-preserving editorial refinement, 2026-10-04. */
(() => {
  'use strict';
  const root = document.querySelector('[data-dhf-product]');
  if (!root || root.dataset.premiumReady || !root.classList.contains('is-enhanced')) return;
  const description = root.querySelector('[data-dhf-description]');
  if (!description) return;
  root.dataset.premiumReady = 'true';
  root.classList.add('dhf-premium');

  // Some imported descriptions put their complete article inside a single list
  // item, or mix sibling heading levels. Wrap those original siblings in place;
  // keep every original ancestor, list item, heading, attribute and text node.
  if (!description.classList.contains('dhf-chaptered')) {
    const candidates = [...new Set([...description.querySelectorAll('h1,h2,h3')].map(heading => heading.parentElement))].flatMap(parent => {
      if (parent.closest('table,blockquote,details')) return [];
      for (let ancestor = parent; ancestor && ancestor !== description; ancestor = ancestor.parentElement) {
        if (/^(UL|OL)$/.test(ancestor.tagName) && (ancestor.children.length !== 1 || ancestor.firstElementChild.tagName !== 'LI')) return [];
      }
      const headings = [...parent.children].filter(node => /^(H1|H2|H3)$/.test(node.tagName));
      const count = tag => headings.filter(heading => heading.tagName === tag).length;
      const tags = count('H2') >= 3 ? ['H2'] : count('H1') >= 3 ? ['H1'] : count('H3') >= 3 ? ['H2','H3'] : [];
      const boundaries = headings.filter(heading => tags.includes(heading.tagName));
      if (boundaries.length < 3) return [];
      const chunks = [];let chunk = {heading:null,nodes:[]};
      [...parent.childNodes].forEach(node => {
        if (boundaries.includes(node)) {
          if (chunk.heading || chunk.nodes.length) chunks.push(chunk);
          chunk = {heading:node,nodes:[]};
        } else chunk.nodes.push(node);
      });
      if (chunk.heading || chunk.nodes.length) chunks.push(chunk);
      if (chunks.filter(item => item.heading && item.nodes.map(node => node.textContent).join('').trim().length >= 30).length < 3) return [];
      return [{parent,chunks,count:boundaries.length}];
    }).sort((a,b) => b.count - a.count);
    const candidate = candidates[0];
    if (candidate) {
      const fragment = document.createDocumentFragment();
      const sources = [...(root.querySelector('[data-dhf-story-source]')?.content.querySelectorAll('figure') || [])];
      const symphonyPhoto = sources.find(figure => figure.dataset.file === '690DD87B-0A1C-432E-AF58-78494DE782CD.jpg');
      const overviewSource = root.dataset.family === 'ambient' ? symphonyPhoto : sources.find(figure => figure.dataset.featured === 'true');
      let first = true, featured = false, anchor = 0;
      candidate.chunks.forEach(chunk => {
        const meaningful = chunk.nodes.some(node => node.textContent.trim() || (node.nodeType === 1 && (node.matches('img,video,iframe,table,model-viewer') || node.querySelector('img,video,iframe,table,model-viewer'))));
        if (!chunk.heading && !meaningful) {
          chunk.nodes.forEach(node => fragment.appendChild(node));return;
        }
        const chapter = document.createElement('section');chapter.className = 'dhf-chapter dhp-recovered dhp-open';
        const intro = first;first = false;
        if (intro) chapter.classList.add('dhf-chapter-intro');
        const title = chunk.heading?.textContent || '';
        const theatre = !intro && !featured && /\bfeatures\b/i.test(title) && !/compatib|important|warning|limitations?/i.test(title);
        let holder = chapter;
        if (intro && overviewSource) {
          chapter.classList.add('dhf-story','dhf-visual-intro');chapter.dataset.tone = 'light';chapter.dataset.side = 'right';
          const figure = overviewSource.cloneNode(true);figure.className = 'dhf-story-media';figure.dataset.dhfAdded = 'media';figure.dataset.fit = root.dataset.family === 'ambient' ? 'cover' : 'contain';
          const walker = document.createTreeWalker(figure,4);const text=[];while(walker.nextNode())text.push(walker.currentNode);text.forEach(node => node.remove());
          figure.querySelector('button').addEventListener('click', () => {
            root.querySelector(`[data-dhf-thumb="${figure.dataset.mediaId}"]`)?.click();
            root.querySelector(`.dhf-slide[data-media-id="${figure.dataset.mediaId}"] [data-dhf-zoom]`)?.click();
          });
          chapter.appendChild(figure);holder = document.createElement('div');holder.className = 'dhf-story-copy';chapter.appendChild(holder);
        } else if (theatre) {
          featured = true;chapter.classList.add('dhf-feature-theatre');chapter.dataset.tone = 'dark';
          holder = document.createElement('div');holder.className = 'dhf-theatre-copy';chapter.appendChild(holder);
        }
        if (chunk.heading) {
          const head = document.createElement('div');head.className = 'dhf-chapter-head';
          do {head.id = `dhp-recovered-topic-${anchor++}`;} while (document.getElementById(head.id));
          head.appendChild(chunk.heading);holder.appendChild(head);
        }
        const body = document.createElement('div');body.className = 'dhf-chapter-body';chunk.nodes.forEach(node => body.appendChild(node));holder.appendChild(body);fragment.appendChild(chapter);
      });
      candidate.parent.appendChild(fragment);
      description.querySelectorAll('.dhp-recovered .dhf-chapter-body').forEach(body => {
        let run = [];
        const finish = () => {
          if (run.filter(node => node.nodeType === 1).length >= 2) {
            const points = document.createElement('div');points.className = 'dhf-feature-points';
            run[0].before(points);run.forEach(node => points.appendChild(node));
          }
          run = [];
        };
        [...body.childNodes].forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'P' && /^[✔✓✅]/.test(node.textContent.trim())) run.push(node);
          else if (run.length && node.nodeType === 3 && !node.textContent.trim()) run.push(node);
          else finish();
        });
        finish();
      });
      description.classList.add('dhf-chaptered','dhp-recovered-source');
    }
  }

  // Keep the original checkmark when the source already supplies a feature icon.
  description.querySelectorAll('.dhf-feature-points > p, .dhf-feature-theatre .dhf-chapter-body > ul > li').forEach(point => {
    const icon = point.querySelector(':scope > .dhf-symbol[data-dhf-added="icon"]');
    if (icon && /^[\s\u200b]*[✓✔✅]/u.test(point.textContent)) icon.dataset.sourceCheck = 'true';
  });

  // Judge.me may feature the same person's identical store and product review.
  // Show that quote once without altering the source reviews or aggregate rating.
  const quoteRail = root.querySelector('[data-dhf-quotes]');
  if (quoteRail) {
    const shownQuotes = new Set();
    const normalise = value => (value || '').replace(/\s+/g,' ').trim();
    [...quoteRail.querySelectorAll('.dhf-quote')].forEach(quote => {
      const body = normalise(quote.querySelector('.dhf-quote-body')?.textContent);
      const author = normalise(quote.querySelector('.dhf-quote-author')?.textContent);
      const rating = quote.querySelector('.dhf-rating-stars')?.getAttribute('aria-label') || '';
      if (!body || !author) return;
      const key = JSON.stringify([author,body,rating]);
      if (shownQuotes.has(key)) quote.remove();
      else shownQuotes.add(key);
    });
    const controls = root.querySelector('[data-dhf-review-controls]');
    if (controls) controls.hidden = quoteRail.children.length < 2;
  }

  const family = root.dataset.family;
  if (family === 'mini-dash') {
    const installedSource = root.querySelector('[data-dhf-story-source]')?.content.querySelector('figure[data-file="fsa1.png"]');
    const introMedia = description.querySelector('.dhf-chapter-intro > figure[data-dhf-added="media"]');
    if (installedSource && introMedia && !description.querySelector('figure[data-file="fsa1.png"]')) {
      const figure = installedSource.cloneNode(true);
      figure.className = introMedia.className;figure.dataset.dhfAdded = 'media';figure.dataset.fit = 'contain';
      const whitespace = document.createTreeWalker(figure,4);const generatedText=[];
      while (whitespace.nextNode()) generatedText.push(whitespace.currentNode);
      generatedText.forEach(node => node.remove());
      figure.querySelector('button').addEventListener('click', () => {
        root.querySelector(`[data-dhf-thumb="${figure.dataset.mediaId}"]`)?.click();
        root.querySelector(`.dhf-slide[data-media-id="${figure.dataset.mediaId}"] [data-dhf-zoom]`)?.click();
      });
      introMedia.replaceWith(figure);
    }
  }
  if (['bmw-dash','vw-seat-dash'].includes(family)) {
    root.querySelectorAll('.dhf-theatre-media[data-dhf-added="media"] img').forEach(image => {
      image.sizes = '(max-width: 767px) 100vw, 90vw';
    });
  }
  const titles = {
    'bmw-dash': ['THE BMW COCKPIT', 'Your BMW. A new point of view.'],
    'vw-seat-dash': ['THE DIGITAL DASHBOARD', 'A fresh perspective on every drive.'],
    'audi-dash': ['THE AUDI COCKPIT', 'The digital cockpit, in detail.'],
    'mercedes-dash': ['THE MERCEDES COCKPIT', 'Take a closer look from the driver’s seat.'],
    'mini-dash': ['THE MINI COCKPIT', 'A fresh view. With MINI character.'],
    'android-screen': ['THE ANDROID EXPERIENCE', 'Explore your screen upgrade.'],
    'carplay-screen': ['THE CONNECTED COCKPIT', 'Your phone. Centre stage.'],
    'carplay-interface': ['THE CARPLAY INTERFACE', 'Your screen. New possibilities.'],
    'ambient': ['THE CABIN EXPERIENCE', 'Set the mood. Make it yours.'],
    'screen-dash-bundle': ['THE COMPLETE COCKPIT', 'Two displays. One cockpit.']
  };
  const identity = titles[family];
  const detailsHead = root.querySelector('.dhf-details-head');
  if (identity && detailsHead) {
    detailsHead.querySelector('.dhf-kicker').textContent = identity[0];
    detailsHead.querySelector('h2').textContent = identity[1];
  }

  // Classify the existing headings, never their values or their claims. A chapter
  // retains every source node, in the original order, including caveats and links.
  function kindFor(chapter) {
    const heading = chapter.querySelector('.dhf-chapter-head');
    const title = heading?.textContent.trim() || '';
    if (chapter.classList.contains('dhf-chapter-intro')) return 'intro';
    if (/compatib|fitment|important|warning|before.*order|please.*(?:read|note)|limitations?|requirements?|options?|selection/i.test(title)) return 'fitment';
    if (/what.*(?:included|box)|in.the.box|package.*(?:includes|contents)|kit.*(?:includes|contents)|\bincluded\b|supplied/i.test(title)) return 'included';
    if (/customi[sz]|personali|display.*(?:styles?|modes?|layouts?)|dashboard styles?|themes?/i.test(title)) return 'styles';
    if (/specification|technical|hardware|processor|performance|premium.*display|high.definition|\d{3,4}\s*[x×]\s*\d{3,4}|digital (?:dashboard )?display/i.test(title)) return 'specs';
    if (/install|plug.*play|fitting/i.test(title)) return 'installation';
    if (/integrat|factory.*(?:function|control)|OEM.*function|original.*(?:retained|system|function)|real.time|vehicle.*(?:data|information)|synchroni[sz]/i.test(title)) return 'integration';
    if (/carplay|android auto|mirroring|connectiv|wireless|bluetooth|navigation|apps?|music|audio|media|android.*(?:system|touchscreen)|how it works|hands.free|voice control/i.test(title)) return 'connectivity';
    if (chapter.classList.contains('dhf-feature-theatre') || /\bfeatures\b/i.test(title)) return 'features';
    if (/lighting|illuminat|ambient|symphony|galaxy|tweeter/i.test(title)) return 'lighting';
    if (/deliver|shipping|dispatch|warranty|support|why choose dhstyling\??$/i.test(title)) return 'service';
    return 'detail';
  }

  const permanentKinds = new Set(['installation','styles','integration','connectivity','specs','included','lighting','features','fitment']);
  let index = 0;
  const chapters = [...description.querySelectorAll('.dhf-chapter')].map(original => {
    let chapter = original;
    const kind = kindFor(chapter);
    // A fitting sequence and the contents of the kit deserve visible space.
    // Replace generated disclosure wrappers, not Shopify's original elements.
    if (chapter.tagName === 'DETAILS' && permanentKinds.has(kind)) {
      const replacement = document.createElement('section');
      [...chapter.attributes].forEach(attr => {
        if (attr.name !== 'open') replacement.setAttribute(attr.name, attr.value);
      });
      const summary = chapter.querySelector(':scope > summary');
      if (summary) {
        const head = document.createElement('div');head.className = summary.className;
        while (summary.firstChild) head.appendChild(summary.firstChild);
        summary.replaceWith(head);
      }
      while (chapter.firstChild) replacement.appendChild(chapter.firstChild);
      chapter.replaceWith(replacement);chapter = replacement;
      chapter.classList.remove('dhf-chapter-disclosure');chapter.classList.add('dhp-open');
    }
    chapter.dataset.premiumKind = kind;
    if (chapter.classList.contains('dhp-recovered') && kind === 'fitment') chapter.classList.add('dhf-chapter-fitment');
    const head = chapter.querySelector('.dhf-chapter-head');
    if (head && kind !== 'intro' && kind !== 'service') {
      chapter.dataset.premiumNumber = String(++index).padStart(2,'0');
      const number = document.createElement('span');number.className = 'dhp-index';
      number.dataset.dhfAdded = 'index';number.setAttribute('aria-hidden','true');
      number.textContent = chapter.dataset.premiumNumber;head.prepend(number);
    }
    const body = chapter.querySelector('.dhf-chapter-body');
    // Give actual source subheadings their own space, preserving source sequence.
    // Only direct children are grouped, leaving nested lists/tables untouched.
    if (body && body.querySelector(':scope > h3, :scope > h4')) {
      const groups = [...body.children].filter(el => /^(H3|H4)$/.test(el.tagName));
      if (groups.length >= 2) {
        let group;
        [...body.childNodes].forEach(node => {
          if (node.nodeType === 1 && /^(H3|H4)$/.test(node.tagName)) {
            group = document.createElement('div');group.className = 'dhp-subsection';
            node.before(group);
          }
          if (group) group.appendChild(node);
        });
        body.classList.add('dhp-subsections');
      }
    }
    if (kind === 'installation' && body?.querySelector('ol')) chapter.classList.add('dhp-timeline');
    return chapter;
  });

  // Replace the old expand control: it held references to the replaced wrappers.
  const oldExpand = detailsHead?.querySelector('.dhf-expand');
  const disclosures = [...description.querySelectorAll('details.dhf-chapter')];
  if (oldExpand) oldExpand.remove();
  if (detailsHead && disclosures.length) {
    const expand = document.createElement('button');expand.type = 'button';expand.className = 'dhf-expand';
    expand.textContent = 'Expand extra details';expand.setAttribute('aria-expanded','false');
    expand.addEventListener('click', () => {
      const open = disclosures.some(item => !item.open);
      disclosures.forEach(item => {item.open = open;});
      expand.textContent = open ? 'Collapse extra details' : 'Expand extra details';
      expand.setAttribute('aria-expanded',String(open));
    });
    detailsHead.appendChild(expand);
  }

  if (detailsHead && chapters.length) {
    const seen = new Set();
    const highlights = chapters.filter(chapter => {
      const kind = chapter.dataset.premiumKind;
      if (!['features','styles','connectivity','integration','lighting','included','installation'].includes(kind) || seen.has(kind)) return false;
      const heading = chapter.querySelector('.dhf-chapter-head :is(h1,h2,h3)');
      if (!(heading?.id || heading?.closest('.dhf-chapter-head')?.id)) return false;
      seen.add(kind);return true;
    }).slice(0,5);
    if (highlights.length >= 2) {
      const nav = document.createElement('nav');nav.className = 'dhp-explore';nav.setAttribute('aria-label','Explore this upgrade');
      const label = document.createElement('p');label.className = 'dhp-explore-label';label.textContent = 'Explore this upgrade';nav.appendChild(label);
      const links = document.createElement('div');links.className = 'dhp-explore-links';nav.appendChild(links);
      highlights.forEach(chapter => {
        const heading = chapter.querySelector('.dhf-chapter-head :is(h1,h2,h3)');
        const link = document.createElement('a');link.className = 'dhp-explore-link';link.href = '#' + (heading.id || heading.closest('.dhf-chapter-head').id);
        const numeral = document.createElement('span');numeral.setAttribute('aria-hidden','true');numeral.textContent = chapter.dataset.premiumNumber;
        const title = document.createElement('span');title.textContent = heading.textContent.trim();
        link.append(numeral,title);links.appendChild(link);
      });
      detailsHead.appendChild(nav);
    }
  }

  // These visually reviewed diagrams belong to this product's native variants.
  // The guide previews images only: it never changes a chosen variant or price.
  const optionFiles = {
    'carplay-screen': ['a51.jpg','a52.jpg','a53.jpg','a54.jpg','a55.jpg','a56.jpg','a57.jpg','a58.jpg'],
    'carplay-interface': ['cicb.jpg','test_2_e65260b2-816a-4216-a605-fcf34cbae48e.webp','id5.webp','id6.webp']
  }[family];
  if (optionFiles) {
    const sources = [...(root.querySelector('[data-dhf-story-source]')?.content.querySelectorAll('figure') || [])];
    const variants = JSON.parse(root.querySelector('[data-dhf-variants]').textContent);
    const used = new Set();
    const choices = variants.flatMap(variant => {
      const figure = sources.find(item => item.dataset.mediaId === String(variant.mediaId) && optionFiles.includes(item.dataset.file));
      if (!figure || used.has(variant.mediaId)) return [];
      used.add(variant.mediaId);
      return [{variant,figure,label:variant.options.join(' / ')}];
    });
    if (choices.length >= 2) {
      const guide = document.createElement('section');guide.className = 'dhp-option-study dhf-wrap';guide.id = 'dhp-option-guide';
      const head = document.createElement('div');head.className = 'dhp-option-study-head';
      const kicker = document.createElement('p');kicker.className = 'dhf-kicker';kicker.textContent = 'PRODUCT OPTIONS';
      const title = document.createElement('h2');title.textContent = 'A closer look at each version.';
      const explanation = document.createElement('p');explanation.textContent = 'Compare the images, then choose your version in the product options.';
      head.append(kicker,title,explanation);guide.appendChild(head);
      const layout = document.createElement('div');layout.className = 'dhp-option-study-layout';
      const controls = document.createElement('div');controls.className = 'dhp-option-study-controls';controls.setAttribute('role','group');controls.setAttribute('aria-label','Product option images');
      const stage = document.createElement('div');stage.className = 'dhp-option-study-stage';
      const caption = document.createElement('p');caption.className = 'dhp-option-study-caption';caption.setAttribute('aria-live','polite');
      const figures = choices.map(choice => {
        const figure = choice.figure.cloneNode(true);figure.dataset.dhfAdded = 'option-guide';
        figure.querySelector('img').sizes = '(max-width: 767px) 100vw, 65vw';
        const zoomButton = figure.querySelector('button');zoomButton.setAttribute('aria-label','Enlarge option image: ' + choice.label);
        zoomButton.addEventListener('click', () => {
          root.querySelector(`[data-dhf-thumb="${choice.variant.mediaId}"]`)?.click();
          root.querySelector(`.dhf-slide[data-media-id="${choice.variant.mediaId}"] [data-dhf-zoom]`)?.click();
        });
        stage.appendChild(figure);return figure;
      });
      let buttons;
      function showChoice(index) {
        figures.forEach((figure,i) => {figure.hidden = i !== index;});
        buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));
        caption.textContent = choices[index].label;
      }
      buttons = choices.map((choice,index) => {
        const button = document.createElement('button');button.type = 'button';button.textContent = choice.label;
        button.setAttribute('aria-label','View option image: ' + choice.label);
        button.addEventListener('click',() => showChoice(index));controls.appendChild(button);return button;
      });
      stage.appendChild(caption);layout.append(controls,stage);guide.appendChild(layout);
      const choose = document.createElement('a');choose.className = 'dhp-option-study-choose';choose.href = '#dhf-product-options';choose.textContent = 'Choose product options ↑';guide.appendChild(choose);
      root.querySelector('.dhf-details').after(guide);
      const purchaseForm = root.querySelector('#form_buy');
      if (purchaseForm) {
        const compare = document.createElement('a');compare.className = 'dhp-compare-options';compare.href = '#dhp-option-guide';compare.textContent = 'Compare version images ↓';
        purchaseForm.before(compare);
      }
      const nav = root.querySelector('.dhf-subnav');
      const link = document.createElement('a');link.href = '#dhp-option-guide';link.textContent = 'Compare options';
      nav.insertBefore(link,nav.lastElementChild);
      const current = root.querySelector('#productSelect')?.value;
      showChoice(Math.max(0,choices.findIndex(choice => String(choice.variant.id) === current)));
    }
  }
})();
